import { Grid, MenuItem, Select, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
// import AntSwitch from '../dailydose/AntSwitch';
import QuillRichTextEditor from './QuillRichTextEditor';

const useStyle = makeStyles({
  questionBox: {
    height: '68vh',
    overflowY: 'auto',
    background: '#F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '10px 20px',
  },
  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  optional_field: {
    color: '#667085',
  },
  inputField: {
    width: '95%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
    '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      '-moz-appearance': 'textfield',
    },
  },
  inputFieldTime: {
    width: '70%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
    '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      '-moz-appearance': 'textfield',
    },
  },
  select: {
    width: '30%',
    marginTop: '5px',
    padding: '5px 10px ',
    background: '#D0D5DD',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    fontWeight: '600',
  },
});

export function ExamInfo({ examInfo, setExamInfo, calledFrom, LOCK_TIME_UNITS, timeUnit, setTimeUnit }) {
  const classes = useStyle();

  const handleChange = (e, name) => {
    if (examInfo?.questionEditRemoveWarning) {
      return;
    }
    const val = e.target.value;
    setExamInfo((pre) => ({
      ...pre,
      [name]: val,
    }));
  };

  const handleStartDateChange = (date) => {
    setExamInfo((pre) => ({
      ...pre,
      startDate: date,
    }));
  };
  const handleEndDateChange = (date) => {
    setExamInfo((pre) => ({
      ...pre,
      endDate: date,
    }));
  };
  // const handleAllowSkipJourneyChange = (e) => {
  //   setExamInfo((pre) => ({
  //     ...pre,
  //     allowSkipJourneys: e.target.checked,
  //   }));
  // };
  const handleInstructions = (e) => {
    setExamInfo((pre) => ({
      ...pre,
      instruction: e,
    }));
  };
  return (
    <Grid className={classes.questionBox}>
      <Grid style={{ width: '97%', display: 'flex', justifyContent: 'space-between' }}>
        <Grid style={{ width: '47%' }}>
          <Typography className={classes.required_field}>Total Questions</Typography>
          <input
            placeholder="ex. 25"
            type="number"
            className={classes.inputField}
            value={examInfo.numberQuestions}
            onChange={(e) => {
              const inp = e.target.value;
              if (inp >= 0) {
                handleChange(e, 'numberQuestions');
              }
            }}
          />
        </Grid>
        <Grid style={{ width: '47%' }}>
          <Typography className={classes.required_field}>Duration (in minutes)</Typography>
          <input
            placeholder="ex. 30"
            className={classes.inputField}
            value={examInfo.duration}
            type="number"
            onChange={(e) => {
              const inp = e.target.value;
              if (inp >= 0) {
                handleChange(e, 'duration');
              }
            }}
          />
        </Grid>
      </Grid>
      <Grid style={{ width: '97%', display: 'flex', justifyContent: 'space-between' }}>
        <Grid style={{ width: '47%' }}>
          <Typography className={classes.required_field}>Passing Score (in percentage)</Typography>
          <input
            placeholder="ex. 80"
            type="number"
            className={classes.inputField}
            value={examInfo.passingScore}
            onChange={(e) => {
              const inp = e.target.value;
              if (inp >= 0) {
                handleChange(e, 'passingScore');
              }
            }}
          />
        </Grid>
        {calledFrom && calledFrom === 'certificate' && (
          <Grid style={{ width: '47%' }}>
            <Typography className={classes.required_field}>Distinction Score (in percentage) </Typography>
            <input
              placeholder="ex. 80"
              type="number"
              className={classes.inputField}
              value={examInfo.distinctionScore}
              onChange={(e) => {
                const inp = e.target.value;
                if (inp >= 0) {
                  handleChange(e, 'distinctionScore');
                }
              }}
            />
          </Grid>
        )}
        {calledFrom && calledFrom === 'collection' && (
          <Grid style={{ width: '47%' }}>
            <Typography className={classes.optional_field}>If failed, lock exam for</Typography>
            <Grid
              style={{
                width: '100%',
                display: 'flex',
              }}
            >
              <input
                placeholder="ex. 48"
                className={classes.inputFieldTime}
                type="number"
                value={examInfo.lockPeriod}
                onChange={(e) => {
                  const inp = e.target.value;
                  if (inp >= 0) {
                    handleChange(e, 'lockPeriod');
                  }
                }}
              />

              <Select
                className={classes.select}
                onChange={(e) => setTimeUnit(e.target.value)}
                value={timeUnit}
                InputProps={{
                  disableUnderline: true,
                }}
              >
                {LOCK_TIME_UNITS?.map((data) => (
                  <MenuItem value={data} key={data}>
                    {data}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        )}
      </Grid>

      {calledFrom && calledFrom === 'certificate' && (
        <Grid style={{ width: '97%', display: 'flex', justifyContent: 'space-between' }}>
          <Grid style={{ width: '47%' }}>
            <Typography className={classes.optional_field}>If failed, lock exam for</Typography>
            <Grid
              style={{
                width: '100%',
                display: 'flex',
              }}
            >
              <input
                placeholder="ex. 48"
                className={classes.inputFieldTime}
                type="number"
                value={examInfo.lockPeriod}
                onChange={(e) => {
                  const inp = e.target.value;
                  if (inp >= 0) {
                    handleChange(e, 'lockPeriod');
                  }
                }}
              />

              <Select
                className={classes.select}
                onChange={(e) => setTimeUnit(e.target.value)}
                value={timeUnit}
                InputProps={{
                  disableUnderline: true,
                }}
              >
                {LOCK_TIME_UNITS?.map((data) => (
                  <MenuItem value={data} key={data}>
                    {data}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        </Grid>
      )}

      {calledFrom && calledFrom === 'collection' && (
        <Grid style={{ width: '97%', display: 'flex', justifyContent: 'space-between' }}>
          <Grid style={{ width: '47%' }}>
            <Typography className={classes.required_field} style={{ marginBottom: '5px' }}>
              Exam Start Date
            </Typography>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                placeholder="YYYY-MM-DD"
                value={examInfo.startDate}
                onChange={handleStartDateChange}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    input: 'date-field',
                  },
                }}
                format="yyyy-MM-dd"
                style={{
                  width: '95%',
                  backgroundColor: 'white',
                  height: '35px',
                  borderRadius: 8,
                  padding: '10px',
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid style={{ width: '47%' }}>
            <Typography className={classes.required_field} style={{ marginBottom: '5px' }}>
              Exam End Date
            </Typography>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                placeholder="YYYY-MM-DD"
                value={examInfo.endDate}
                onChange={handleEndDateChange}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    input: 'date-field',
                  },
                }}
                format="yyyy-MM-dd"
                style={{
                  width: '95%',
                  backgroundColor: 'white',
                  height: '35px',
                  borderRadius: 8,
                  padding: '10px',
                }}
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      )}
      {/* {calledFrom && calledFrom === 'collection' && (
        <Grid style={{ width: '97%', display: 'flex', justifyContent: 'space-between' }}>
          <Grid container style={{ width: '47%', alignItems: 'center' }}>
            <Typography className={classes.required_field} style={{ marginBottom: '5px', marginRight: '20px' }}>
              Allow users to skip
            </Typography>
            <AntSwitch
              checked={examInfo.allowSkipJourneys}
              onChange={handleAllowSkipJourneyChange}
              inputProps={{ 'aria-label': 'ant design' }}
            />
          </Grid>
        </Grid>
      )} */}

      <Grid>
        <Typography className={classes.required_field}>Instructions </Typography>
        <Grid item style={{ marginTop: '5px' }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item style={{ width: '97%' }}>
              <QuillRichTextEditor value={examInfo.instruction} changeFn={handleInstructions} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
